import React, { FunctionComponent, memo, useCallback, useEffect, useState } from "react";
import CustomModal from "../CustomModal/CustomModal";
import styles from "./AutoFillModal.module.scss";
import { getAutoFillingVariants } from "../../../store/helpers/getAutoFillingVariants";
import { Radio } from "../../shared/ui";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Collapse from '@mui/material/Collapse';
import PowerIcon from "../../icons/PowerIcon";
import LikeIcon from "../../icons/LikeIcon";
import { Stack } from "@mui/material";
import { StoreWallInterface } from "../../../store/types/store";
type PropsType = {
    onClose: () => void;
    isOpenModal: boolean;
    addSectionInShelf: (width: number, isIndent: boolean) => void;
    currentShelf: StoreWallInterface

};
//TODO сильно тут не ковырял, я не уверен что тут нужны memo, useCallback, useEffect
const AutoFillModal: FunctionComponent<PropsType> = memo(({ onClose, isOpenModal, addSectionInShelf, currentShelf }) => {
    const totalLength = currentShelf.length;
    const [expanded, setExpanded] = useState<boolean>(false)
    const handleExpand = () => {
        setExpanded((prevState) => !prevState)
    };

    const [variants, setVariants] = useState<number[][]>([])
    const [selected, setSelected] = useState<string | null>(null);

    useEffect(() => {
        const newVariants = getAutoFillingVariants(totalLength);
        
        const optimal = [
            newVariants
                .filter((v) => {
                    const count480 = v.filter((w) => w === 480).length;
                    const count600 = v.filter((w) => w === 600).length;
                    const count800 = v.filter((w) => w === 800).length;

                    return count480 < count600 && count480 < count800;
                })
                .sort((a, b) => a.length < b.length ? -1 : 1)[0],
            newVariants
                .filter((v) => {
                    const count480 = v.filter((w) => w === 480).length;
                    const count600 = v.filter((w) => w === 600).length;
                    const count800 = v.filter((w) => w === 800).length;

                    return count480 > count600 && count480 > count800;
                })
                .sort((a, b) => a.length < b.length ? 1 : -1)[0]
        ].filter((v) => !!v);

        const bestPriceOption = optimal[0] || newVariants[0];
        setSelected(JSON.stringify(bestPriceOption))
        setVariants(newVariants)
    }, [totalLength])

    const handleSelect = (index: string) => () => {
        setSelected(index)
    }

    const handleAutoFill = useCallback(() => {
        variants.find((v) => JSON.stringify(v) === selected)?.map((width) => addSectionInShelf(width, false));
        onClose();
    }, [variants, selected, addSectionInShelf])

    const optimal = [
        variants
            .filter((v) => {
                const count480 = v.filter((w) => w === 480).length;
                const count600 = v.filter((w) => w === 600).length;
                const count800 = v.filter((w) => w === 800).length;

                return count480 < count600 && count480 < count800;
            })
            .sort((a, b) => a.length < b.length ? -1 : 1)[0],
        variants
            .filter((v) => {
                const count480 = v.filter((w) => w === 480).length;
                const count600 = v.filter((w) => w === 600).length;
                const count800 = v.filter((w) => w === 800).length;

                return count480 > count600 && count480 > count800;
            })
            .sort((a, b) => a.length < b.length ? 1 : -1)[0]
    ].filter((v) => !!v)

    const more = variants
        .filter((v) => !optimal.map((o) => JSON.stringify(o)).includes(JSON.stringify(v)))

    const renderVariantRow = (type: 'optimal' | 'more' | 'all') => (variant: number[], i: number) => (
        <tr key={JSON.stringify(variant)} onClick={handleSelect(JSON.stringify(variant))}>
            <td>
                <Radio checked={selected === JSON.stringify(variant)} size="small"/>
            </td>
            {
                [480, 600, 800].map((v) => (
                    <td>
                        <div className={styles.sections}>
                            {!!variant.filter((w) => w === v).length &&
                                <span key={v}>
                                    {variant.filter((w) => w === v).length && `${variant.filter((w) => w === v).length}`}
                                </span>
                            }
                        </div>
                    </td>
                ))
            }
            <td>
                {variant.reduce((a, b) => a + b, 0)} мм
            </td>
            <td>
                {totalLength - variant.reduce((a, b) => a + b, 0)} мм
            </td>
            <td>
                {(type === 'more') && 'Дополнительный вариант'}
                {(type === 'optimal' && i === 1) &&
                    <Stack direction="row" spacing={0.5}><PowerIcon/><span>Большая прочность</span></Stack>}
                {(type === 'optimal' && i === 0) &&
                    <Stack direction="row" spacing={0.5}><LikeIcon/><span>Лучшая цена</span></Stack>}
            </td>
        </tr>
    )

    return (
        <CustomModal
            isOpenModal={isOpenModal}
            onCloseModalCallback={onClose}
        >
            <div className={styles.root}>
                <div className={styles.header}>Варианты автозаполнение</div>
                <div className={styles.tableContainer}>
                    <table className={styles.table}>
                        <thead className={styles.tableHeader}>
                        <tr>
                            <th></th>
                            <th style={{ textAlign: "center" }}>480 мм</th>
                            <th style={{ textAlign: "center" }}>600 мм</th>
                            <th style={{ textAlign: "center" }}>800 мм</th>
                            <th>Длина</th>
                            <th>Остаток</th>
                            <th>Особенность</th>
                            </tr>
                        </thead>
                        <tbody>
                            {variants.length > 2 ? (
                                <>
                                    {optimal.map(renderVariantRow('optimal'))}
                                    {!!more.length && (
                                        <>
                                            <tr className={styles.expandRow}>
                                                <td colSpan={7}>
                                                    <div className={styles.expandBtn} onClick={handleExpand}>
                                                        <span>Еще варианты</span>
                                                        {expanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
                                                    </div>
                                                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                                                        <table className={styles.table}>
                                                            <tbody>
                                                                {more.map(renderVariantRow('more'))}
                                                            </tbody>
                                                        </table>
                                                    </Collapse>
                                                </td>
                                            </tr>
                                        </>
                                    )}
                                </>
                            ) :
                                <>
                                    {variants.map(renderVariantRow('all'))}
                                </>
                            }
                        </tbody>
                    </table>
                </div>
                <button onClick={handleAutoFill} className={styles.submit}>
                    Применить
                </button>
            </div>
        </CustomModal>
    );
});

export default AutoFillModal;
